import storeEmbeddedValues from 'rlink-data-connector/storeEmbeddedValues';
import setRequestFailed from 'rlink-data-connector/setRequestFailed';
import Rx from 'rlink-rx';
import inspectable from 'rlink-inspectable-error';
import areStoreSetActions from 'rlink-data-connector/areStoreSetActions';
import areEmbeddedValues from 'rlink-data-connector/areEmbeddedValues';

import requestDataCache from './requestDataCache';

function onStreamValues (dispatch) {
  return function (embeddedValues) {
    if (Rx.Observable.isObservable(embeddedValues)) {
      embeddedValues.subscribe(onStreamValues(dispatch));
    } else if (areStoreSetActions(embeddedValues)) {
      embeddedValues.map(dispatch);
    } else if (areEmbeddedValues(embeddedValues)) {
      dispatch(storeEmbeddedValues(
        ...(Array.isArray(embeddedValues)
          ? embeddedValues
          : [embeddedValues]
        )
      ));
    } else {
      throw inspectable`Invalid embedded values ${embeddedValues}`;
    }
  };
}

export default function requestData (initiatingRequest, ...initiatingRequestArgs) {
  return (dispatch, getState, thunkArgs) => {
    function getCaches () {
      return getState().caches;
    }
    function getRequestStreamAndSubscription (request, ...requestArgs) {
      let requestKey = request.keyFor(...requestArgs);
      let [subject, subscription] = requestDataCache.get(requestKey) || [];

      if (!subject) {
        subject = new Rx.Subject();
      }

      let requestStreamProvider = request.type.getRequestStreamProvider(request, requestArgs, thunkArgs);
      let stream = requestStreamProvider({
        getCaches,
        getRequestStream,
        getRequestStreamAndSubscription,
        request,
        requestArgs,
      });

      if (!subscription || subscription.isDisposed) {

        stream.catch(error => Rx.Observable.just([setRequestFailed(request, requestArgs, error)]));

        subscription = stream.subscribe(
          value => {
            subject.onNext(value);
            onStreamValues(dispatch)(value);
          },
          error => {
            subject.onError(error);
            dispatch(setRequestFailed(request, requestArgs, error));
          },
          () => {
            subject.onCompleted();
          }
        );

        requestDataCache.set(requestKey, [subject, subscription]);
      }

      return {subscription, stream};
    }
    function getRequestStream (request, ...requestArgs) {
      return getRequestStreamAndSubscription(request, ...requestArgs).stream;
    }
    return getRequestStreamAndSubscription(initiatingRequest, ...initiatingRequestArgs);

  };
}



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/requestData.js